import React from "react";

import * as Styled from "./styles";

const Dashboard = () => {
  return <Styled.Container />;
};

export default Dashboard;
